
import React, { useState, useEffect, useContext } from "react";
import Swal from 'sweetalert2';
import { AuthContext } from '../contexts/auth';



const EmployeeEmailNotificationSetting = ({ isEmailEnabled, isPushEnabled, isLoading, onChangeSetting }) => {

return (
    <div className="max-w-full px-4 mx-auto">
        <div className="flex justify-between items-center py-2">
            <div className="text-sm font-semibold text-gray-900">
                Abilita ricezione email
            </div>
            <div>
                {isLoading ? 'Caricamento...' : (
                <input
                    type="checkbox"
                    className="h-5 w-5 rounded text-indigo-600 focus:ring-indigo-600"
                    checked={isEmailEnabled}
                    onChange={(e) => onChangeSetting("employee_email_enabled", e.target.checked)}
                />
                )}
            </div>
        </div>
  
        <div className="flex justify-between items-center py-2">
            <div className="text-sm font-semibold text-gray-900">
                Abilita ricezione notifiche push
            </div>
            <div>
                {isLoading ? 'Caricamento...' : (
                <input
                    type="checkbox"
                    className="h-5 w-5 rounded text-indigo-600 focus:ring-indigo-600"
                    checked={isPushEnabled}
                    onChange={(e) => onChangeSetting("employee_push_notification_enabled", e.target.checked)}
                />
                )}
            </div>
        </div>
      </div>
    );
}  

export default EmployeeEmailNotificationSetting;